import { useMemo } from 'react';
import { useGetBillRequestsForXeroBatchPayment } from 'shared/data/webApp/v1';

import { mapXeroBillInvoiceRequests } from './XeroBillBatchPaymentForm.helpers';
import { UseBillsForBatchPaymentData } from './XeroBillBatchPaymentForm.types';

export const useBillsForBatchPaymentData = ({
    companyId,
    filterTransfer,
    integrationCountryCode,
    enabled = true,
}: UseBillsForBatchPaymentData) => {
    const { data, isLoading } = useGetBillRequestsForXeroBatchPayment(
        {
            query: { companyId, ...filterTransfer },
        },
        { enabled }
    );

    const mappedData = useMemo(
        () => mapXeroBillInvoiceRequests(data?.items || [], integrationCountryCode),
        [data?.items, integrationCountryCode]
    );

    return {
        billsForBatchPaymentData: mappedData,
        billsForBatchPaymentLoading: isLoading,
    };
};
